import { render, staticRenderFns } from "./NextPetTagCTA.vue?vue&type=template&id=15b77ed8&scoped=true&"
import script from "./NextPetTagCTA.vue?vue&type=script&lang=js&"
export * from "./NextPetTagCTA.vue?vue&type=script&lang=js&"
import style0 from "./NextPetTagCTA.vue?vue&type=style&index=0&id=15b77ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b77ed8",
  null
  
)

export default component.exports